/**
 * Every user-facing string on the Bulk Upload screen.
 *
 * Kept out of the components so wording can be reviewed (or translated) in one
 * place, and so no component carries a literal of its own.
 */

import { FILE_CONSTRAINTS } from "./BulkUploadConfigJson";

const extensionList = FILE_CONSTRAINTS.acceptedExtensions.join(", ");

export const BULK_UPLOAD_MESSAGES = {
  page: {
    breadcrumbRoot: "Settings",
    breadcrumbCurrent: "Bulk Upload",
    breadcrumbLink: "/settings/bulkorder",
  },

  table: {
    typeColumn: "Upload Type",
    descriptionColumn: "Description",
    templateColumn: "Template",
    uploadColumn: "Upload File",
    uploadAction: "Upload",
    templateAction: "Template",
  },

  modal: {
    hint: "The result file will be available to download once the upload finishes.",
  },

  dropzone: {
    prompt: "Drag and drop your file here, or",
    browse: "browse",
    hint: `${extensionList} · up to ${FILE_CONSTRAINTS.maxSizeMb} MB`,
    ariaLabel: "Select or drop a spreadsheet to upload",
  },

  file: {
    remove: "Remove",
    upload: "Upload",
    uploading: "Uploading...",
  },

  result: {
    heading: "Result file is ready",
    download: "Download",
    completed: "Upload complete.",
    downloadHint: "Upload complete. Download the result file to review each row.",
  },

  validation: {
    noFile: "Please select a file to upload.",
    unsupportedType: `Unsupported file type. Please upload ${extensionList}.`,
    emptyFile: "The selected file is empty.",
    tooLarge: `File is too large. The maximum size is ${FILE_CONSTRAINTS.maxSizeMb} MB.`,
  },

  errors: {
    uploadFailed: "Upload failed. Please try again.",
    missingEndpoint: (type) => `No bulk upload endpoint is configured for "${type}".`,
  },
};
